let data151;
if (typeof window === "undefined") {
  data151 = require("../static-s151/Data.json");
} else {
  // data151 = require("../static-s151/Data.json");
  // window.data151 = data151;
  data151 = window.data151;
}

export { data151 };
